/*
 * Form submit — отправка через /api/send.php.
 *
 * Что делает:
 *   - перехватывает submit на всех <form class="form" data-form>
 *   - запускает нативную HTML5-валидацию (required, type)
 *   - отправляет данные на /api/send.php через fetch()
 *   - управляет состояниями: idle → loading → submitted / error
 */

function initForms() {
  const forms = document.querySelectorAll('form.form[data-form]');

  forms.forEach((form) => {
    const submitBtn = form.querySelector('[type="submit"]');
    const submitBtnText = submitBtn ? submitBtn.textContent : '';

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      // Loading state
      form.dataset.state = 'loading';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Отправка...';
      }
      clearFormError(form);

      try {
        const data = new FormData(form);
        const res = await fetch('/api/send.php', {
          method: 'POST',
          body: data,
        });

        const json = await res.json();

        if (!res.ok || !json.ok) {
          const msg =
            json.error || (json.errors ? Object.values(json.errors).join('. ') : 'Ошибка отправки');
          throw new Error(msg);
        }

        // Success
        form.dataset.state = 'submitted';
        form.reset();
      } catch (err) {
        form.dataset.state = 'error';
        showFormError(form, err.message || 'Не удалось отправить. Попробуйте позже.');
      } finally {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtnText;
        }
      }
    });

    // Retry button — return to idle
    const retryButton = form.querySelector('[data-form-retry]');
    if (retryButton) {
      retryButton.addEventListener('click', () => {
        form.dataset.state = 'idle';
        clearFormError(form);
      });
    }
  });
}

function showFormError(form, message) {
  const el = form.querySelector('.form__error-global');
  if (el) {
    el.textContent = message;
  }
}

function clearFormError(form) {
  const el = form.querySelector('.form__error-global');
  if (el) {
    el.textContent = '';
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initForms);
} else {
  initForms();
}
